<template>
    <div class="addStao">
        <div class="infoHolder">
            <i id="closeInfo" class="material-icons" @click="closeAdd">close</i>
            <form class="userInfoForm" autocomplete="off">
                stao name
                <input id="createUnum" class="staoInfoInput" type="text" placeholder="name" v-model="newStaoInfo.name">
                diag:
                <select id="createStao" v-model="newStaoInfo.diag">

                    <option value=0
                            class="staoInfoInput">
                        -
                    </option>
                    <option value=1
                            class="staoInfoInput">
                        diag
                    </option>

                </select>

                <button class="createButton" @click.prevent="create">create</button>
            </form>
        </div>
    </div>
</template>

<script>

export default {
    data () {
        return {
            newStaoInfo: {
                name: '',
                diag: 0
            }
        }
    },
    computed: {
        staos () {
            return this.$store.getters['user/staos'];
        }

    },
    methods: {
        closeAdd () {
            this.$router.go(-1);
        },
        create () {
            
            this.$store.dispatch('user/addStao', this.newStaoInfo);
        }
    },
    mounted () {
    }
}
</script>

<style scoped sass>
    #closeInfo {
        position: absolute;
        top: 0;
        right: 0;
        cursor: pointer;
        font-size: 40px;
    }

    .addStao {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100vh;
        display: flex;
        justify-content: center;
        align-items: center;
        /*background-color: blue;*/
    }

    .infoHolder {
        position: relative;
        display: flex;
        flex-direction: column;
        width: 100%;
        /*height: 200px;*/
        background-color: white;
        box-shadow: 0px 0px 60px grey;
        padding-top: 10px;
        padding-bottom: 10px;
    }

    .userInfoForm {
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin-left: 20px;
        margin-right: 40px;
    }

    #createStao {
        height: 50px;
        font-size: 25px;
    }

    #createLagerCheff {
        height: 50px;
        font-size: 25px;
    }

    .staoInfoInput {
        font-size: 20px;

    }

    .createButton {
        width: 100%;
        color: white;
        font-size: 20px;
        background-color: green;
    }

    @media screen and (min-width: 500px) {
        .infoHolder {
            width: 500px;
        }

    }

    @media screen and (min-width: 1300px) {
        .infoHolder {
            width: 600px;
        }

        .staoInfoInput {
            font-size: 30px;

        }

        .saveButton {
            font-size: 40px;
        }

    }

</style>
